export const TEST_DRIVE = 'TEST_DRIVE';
export const APPOINTMENT = 'APPOINTMENT';
export const SAVE_TO_GARAGE = 'SAVE_TO_GARAGE';
export const GET_STARTED = 'GET_STARTED';
export const ASK_QUESTIONS = 'ASK_QUESTIONS';

export default {
    TEST_DRIVE,
    APPOINTMENT,
    SAVE_TO_GARAGE,
    GET_STARTED,
    ASK_QUESTIONS,
};
